import { message } from "antd";
import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiComplete } from "./api";

export const filetransferjobGet = () => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.get(
        "/api/sftpJobConfiguration/getjob",
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      dispatch(apiComplete());

      // //console.log(result.data);

      return result.data;
    } catch (error) {
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error",
      );
      dispatch(apiComplete());
      return [];
    }
  };
};

export const filetransferjobEdit = (id) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.get(
        `/api/sftpJobConfiguration/editjob/${id}`,
        null,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      dispatch(apiComplete());
      ////console.log(result.data);

      return result.data;
    } catch (error) {
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error",
      );
      dispatch(apiComplete());
      return [];
    }
  };
};

/////////////////////////////////////////////////// sftp - Manual Job execution ////////////////

export const manualJobexec = (params) => {
  return async (dispatch) => {
    dispatch(apiStart());
    try {
      const result = await axiosBackEnd.post(
        "/api/sftpmanualjobexecute/manualJobexec",
        params,
        {
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(params),
        },
      );
      //console.log(params,result,'submit params')
      dispatch(apiComplete());
      message.success("Execute The Manual Job Successfully");

      return true;
    } catch (error) {
      dispatch(apiComplete());
      //console.log(error)
      message.error(
        error.response !== undefined && typeof error.response.data === "string"
          ? error.response.data
          : "Internal Server Error",
      );
      return false;
    }
  };
};
